import React, { Component } from "react";
import style from "../../../assets/css/modules/claims/claims-summary-cell.css";

export default class CellWithTwoLabels extends Component {
  render() {
    const styles = this.props.styles ? this.props.styles : style;

    return (
      <div className={styles.claimSummaryCell}>
        <div
          className={styles.topLabel + " " + this.props.topLabelStyleOverride}
        >
          {this.props.topLabel}
        </div>
        <div
          className={
            styles.bottomLabel + " " + this.props.bottomLabelStyleOverride
          }
        >
          {this.props.bottomLabel}
        </div>
      </div>
    );
  }
}
